/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useState, useEffect } from "react";
import { Form, Dropdown, Label, Grid, Icon, Checkbox } from "semantic-ui-react";
import PropTypes from "prop-types";

import Joi from "joi";
// Components
import { isEmpty, map, toLower, isEqual, trim, get } from "lodash";
import IKModal from "@Components/IkModal";

// Modals
import { connect } from "react-redux";
import ConfirmModal from "@Modals/ConfirmModal";
import genericAction from "@Actions/generic";

// redux
import { dropdownFormat } from "@Utils/formats";
import Input from "@Components/Input";
import Text from "@Components/Text";
// Styles
import styles from "./styles.module.css";

const CategoryCrud = ({ modalCrud, tableValue, onClose, apiData, categoryData, typesList, dispatch, defaultType, refresh }) => {
	const schema = Joi.object().keys({
		nameCategory: Joi.string().min(4).messages({
			"string.min": "Nombre debe tener mínimo 4 caracteres",
			"string.empty": "Nombre es un campo requerido",
		}),
		nombreCategoryRepet: Joi.string().messages({
			"string.empty": "El Título ya existe",
		}),
		types: Joi.array().min(1).messages({
			"array.min": "Tipos es un campo requerido",
		}),
	});

	const [open, setOpen] = useState(false);
	const [typesData, setTypesData] = useState([]);
	const [errors, setErrors] = useState([]);
	const [initialFormData, setInitialFormData] = useState([]);
	const [modalOption, setModalOption] = useState("");
	const [formData, setFormData] = useState({
		nameCategory: "",
		types: [],
		aplica_nota: false,
	});
	const [isPinned, setIsPinned] = useState(!!defaultType);

	useEffect(() => {
		setModalOption(modalCrud);
		const formattedTypes = dropdownFormat(typesList, "name", "value");
		if (
			defaultType &&
			!formattedTypes.some((opt) => {
				return opt.value === defaultType;
			})
		) {
			formattedTypes.push({
				key: defaultType,
				text: "Respuestas Rápidas",
				value: defaultType,
			});
		}
		setTypesData(formattedTypes);

		const defaultTypes = modalCrud === "Add" && defaultType ? [defaultType] : get(tableValue, "restriction", []);
		const aplicaNota = get(tableValue, "settings.aplica_nota", false);
		setInitialFormData({
			nameCategory: get(tableValue, "name", ""),
			types: defaultTypes,
			aplica_nota: aplicaNota,
		});
		setFormData({
			nameCategory: get(tableValue, "name", ""),
			types: defaultTypes,
			aplica_nota: aplicaNota,
		});
	}, [tableValue, modalCrud, defaultType, typesList]);

	// handle save
	const handlerSaved = async () => {
		let nombreCategoryRepet = "ejemplo";

		if (modalOption === "Add") {
			map(categoryData, (item) => {
				if (toLower(item.name) === toLower(formData.nameCategory)) {
					nombreCategoryRepet = "";
				}
			});
		}
		const validation = schema.validate(
			{
				nameCategory: formData.nameCategory,
				nombreCategoryRepet,
				types: formData.types,
			},
			{ abortEarly: false }
		);
		if (validation.error) {
			const { details } = validation.error;
			let errorsVal = {
				nameCategory: "",
				nombreCategoryRepet: "",
				types: [],
			};
			map(details, (item) => {
				errorsVal = { ...errorsVal, [item.context.key]: item.message };
			});
			setErrors(errorsVal);
		} else {
			let nameValue = formData.nameCategory;
			if (isEmpty(formData.nameCategory)) {
				nameValue = null;
			}
			const data = { name: trim(nameValue), restriction: formData.types, settings: { aplica_nota: formData.aplica_nota } };

			if (modalOption === "Add") {
				const dataAdd = await dispatch(genericAction({ method: "post", route: "category", body: data }));

				if (!isEmpty(dataAdd)) {
					apiData("Add", dataAdd);
					refresh();

					if (isPinned) {
						setFormData({ ...formData, nameCategory: "" });
					} else {
						onClose(dataAdd);
					}
					return;
				}
			} else {
				const dataEdit = await dispatch(genericAction({ method: "patch", route: `category/${tableValue.id}`, body: data }));
				if (!isEmpty(dataEdit)) {
					apiData("Edit");
					refresh();
				}
			}

			setErrors({
				nameCategory: "",
				nombreCategoryRepet: "",
				types: [],
			});
		}
	};

	// modal
	const cancelModal = () => {
		onClose();
	};

	const modalOpen = () => {
		if (isEqual(initialFormData, formData)) {
			cancelModal();
		} else if (open) {
			setOpen(false);
		} else {
			setOpen(true);
		}
	};

	// input handler
	const handleInputDropdown = (event, { name, value }) => {
		setFormData({
			...formData,
			[name]: value,
		});
	};

	const handleInput = (e) => {
		const { name, value } = e.target;
		setFormData({
			...formData,
			[name]: value,
		});
	};
	return (
		<>
			<IKModal
				title={modalOption === "Add" ? "Agregar Categoría" : `Categoría: ${get(tableValue, "name", "")} `}
				id={tableValue.id}
				mode={modalOption}
				setMode={setModalOption}
				onClose={modalOpen}
				onSuccess={handlerSaved}
				size="tiny"
				saveDisabled={modalOption === "Edit" && isEqual(initialFormData, formData)}>
				<Grid className={styles.grid}>
					<Grid.Row className={styles.grid}>
						<Grid.Column width={16} className={styles.grid}>
							<fieldset className={styles.fieldset}>
								<div>
									<Form>
										<Input
											value={formData.nameCategory}
											// icon="unordered list"
											required
											label="Nombre:"
											placeholder="Nombre"
											name="nameCategory"
											disabled={modalOption === "Watch"}
											fluid
											error={!isEmpty(errors.nameCategory) && { content: errors.nameCategory, pointing: "above" }}
											onChange={handleInput}
											className={styles.typeDrop}
										/>
										{!isEmpty(errors.nombreCategoryRepet) && (
											<Label className={styles.messageError} pointing prompt>
												{errors.nombreCategoryRepet}
											</Label>
										)}

										<Text className={styles.textBox}>
											Tipos:
											<span className={styles.required}>*</span>
										</Text>
										<div className={styles.typeDrop} style={{ display: "flex", alignItems: "center", gap: "2px" }}>
											<Dropdown
												fluid
												placeholder="Seleccionar"
												value={formData.types}
												size="mini"
												name="types"
												disabled={modalOption === "Watch" || !!defaultType}
												search
												selection
												multiple
												clearable
												onChange={handleInputDropdown}
												options={typesData}
												direction="right"
												upward
												style={{ flex: 1 }}
											/>
											{modalOption === "Add" && (
												<div
													className={`${styles.pinIcon} ${isPinned ? styles.pinIconActive : ""}`}
													onClick={() => {
														return setIsPinned(!isPinned);
													}}
													title="Fijar tipo">
													<Icon name="pin" size="large" style={{ margin: 0 }} />
												</div>
											)}
										</div>

										<Label className={styles.messageError} style={isEmpty(errors.types) ? { display: "none" } : null} pointing prompt>
											{errors.types}
										</Label>

										<div className={styles.typeDrop} style={{ marginTop: "10px", display: "flex", alignItems: "center", gap: "8px" }}>
											<Checkbox
												toggle
												label="Aplica Nota"
												checked={formData.aplica_nota}
												disabled={modalOption === "Watch"}
												onChange={(e, { checked }) => {
													return setFormData({ ...formData, aplica_nota: checked });
												}}
											/>
										</div>
									</Form>
								</div>
							</fieldset>
						</Grid.Column>
					</Grid.Row>
				</Grid>
			</IKModal>
			{open && (
				<ConfirmModal
					buttonLabel="Salir"
					visible
					header="Salir del formulario"
					content="Está seguro que desea salir del formulario"
					onConfirm={cancelModal}
					onDismiss={modalOpen}
				/>
			)}
		</>
	);
};

function mapStateToProps({ company, user }) {
	return {
		companyName: company.name,
		userName: user.name,
	};
}
CategoryCrud.propTypes = {
	tableValue: PropTypes.array,
	onClose: PropTypes.func,
	apiData: PropTypes.func,
	categoryData: PropTypes.array,
	typesList: PropTypes.array,
	dispatch: PropTypes.func,
	modalCrud: PropTypes.array,
	defaultType: PropTypes.string,
	refresh: PropTypes.func,
};
export default connect(mapStateToProps)(CategoryCrud);
